// https://api.jquery.com/jquery.extend/#jQuery-extend-deep-target-object1-objectN
( function () {
    'use strict';
    jQuery.extend( true, e4.settings, {
        area: {
            urlName: ( function () {
                return jQuery( 'html' ).data( 'area-url-name' ).toString();
            }() )
        }
    } );
    jQuery.extend( true, e4.settings, {
        ecom: {
            ordermatrix: {
                url: e4.settings.area.urlName + '/system/data/ordermatrix'
            },
            varianthandler: {
                url: e4.settings.area.urlName + '/system/data/variant'
            },
            quickorder: {
                url: '/eldorado-api/session/QuickOrderSearch/GetProductsBySearchQuery'
            },
            filters: {
                cleanUrl: false,
                url: e4.settings.area.urlName + '/system/data/products-with-filters'
            },
            products: {
                url: e4.settings.area.urlName + '/system/data/products-with-filters'
            },
            cart: {
                url: e4.settings.area.urlName + '/system/data/cart',
                msgHideDelay: 3000
            },
            cartCount: {
              url: e4.settings.area.urlName + '/system/data/cartcount'  
            },
            checkout: {
                url: e4.settings.area.urlName + '/system/data/checkout',
                termsAndConditions: e4.settings.area.urlName + '/shop/terms-and-conditions'
            },
            parcelShops: {
                url: e4.settings.area.urlName + '/system/data/parcel-shops'
            },
            favorites: {
                url: e4.settings.area.urlName + '/system/data/favorites'
            },
            product: {
                url: e4.settings.area.urlName + '/system/data/product'
            }
        },
        dealersearch: {
            url: e4.settings.area.urlName + '/system/data/dealersearch'
        },
        rma: {
            orderlines: {
                url: '/eldorado-api/session/rmacases/GetAxOrderlines'
            },
            case: {
                create: {
                    url: '/eldorado-api/session/rmacases/CreateRmaCase'
                },
                confirm: {
                    url: '/eldorado-api/session/rmacases/ConfirmRmaCase'
                },
                close: {
                    url: '/eldorado-api/session/rmacases/CloseRmaCase'
                },
                addLine: {
                    url: '/eldorado-api/session/rmacases/AddRmaCaseLine'
                },
                deleteLine: {
                    url: '/eldorado-api/session/rmacases/DeleteRmaCaseLine'
                },
                updateLine: {
                    url: '/eldorado-api/session/rmacases/UpdateRmaCaseLine'
                },
                updateLines: {
                    url: '/eldorado-api/session/rmacases/UpdateRmaCaseLines'
                },
                listExternal: {
                    url: e4.settings.area.urlName + '/system/data/rma-cases-external'
                },
                listInternal: {
                    url: e4.settings.area.urlName + '/system/data/rma-cases-internal'
                }
            },
            caseLines: {
                listInternal: {
                    url: e4.settings.area.urlName + '/system/data/rma-case-lines-internal'
                }
            },
            user: {
                list: {
                    url: '/eldorado-api/session/rmacases/GetRmaUsers'
                },
                impersonate: {
                    url: '/eldorado-api/session/rmacases/ChangeRmaUser'
                },
                consultants: {
                    url: '/eldorado-api/session/rmacases/GetRmaLevel3UsersByCaseId'
                }
            },
            upload: {
                url: e4.settings.area.urlName + '/system/data/rma-upload'
            }
        },
        extranet:{
            impersonation: {
                url: e4.settings.area.urlName + '/system/data/users-impersonatable' 
            }
        },
        search: {
            result: {
                pages: {
                    show: false,
                },
                products: {
                    show: true,
                    url: e4.settings.area.urlName + '/system/data/products?q',
                    rawurl: e4.settings.area.urlName + '/system/data/products',
                    showAllLink: e4.settings.area.urlName + '/shop/search?q='
                }
            }
        },
        require: {
            typeahead: {
                url: '/files/system/espresso/design/_assets/js/vendor/typeahead.jquery.js'
            }
        }
    } );
}() );
